import React, { useEffect } from 'react'
import MyBlock from '../UI/block/MyBlock'
import LoginForm from './form/LoginForm'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const Login = () => {

	const isAuth = useSelector(state => state.user.isAuth)
	const navigate = useNavigate()

	useEffect(() => {
		if (isAuth) {
			navigate('/')
		}
	}, [isAuth])

  return (
    <div className='loginPage'>
		<div className='loginPage__form'>
			<MyBlock>
				<h2>Вхід</h2>
				<LoginForm />
			</MyBlock>
		</div>
	</div>
  )
}

export default Login